import {ChangeDetectorRef, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ContentService} from "../_services/content.service";
import {CreatePostComponent} from "../shared/create-post/create-post.component";
import {User} from '../_types/user';
import {DashboardFeedComponent} from './dashboard-feed/dashboard-feed.component';
import {AuthService} from '../_services/auth.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {take} from 'rxjs';
import {FeedPost} from '../_types/content';
import {CommentsComponent} from "../shared/comments/comments.component";
import {Community, UserAccessLevel} from "../_types/communities";
import {ActivatedRoute, Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ThemeService} from "../_services/theme.service";


@Component({
    selector: 'app-feed',
    templateUrl: './feed.component.html',
    styleUrl: './feed.component.scss'
})
export class FeedComponent implements OnInit {
    @ViewChild(DashboardFeedComponent) dashboardFeedComponent!: DashboardFeedComponent;
    currentCommunityId: number | null = null;
    loading: boolean = false;
    sidebarPosts: FeedPost[] = [];

    community: Community | null = null
    isMobile: boolean = false;

    constructor(public dialog: MatDialog,
                private authService: AuthService,
                private contentService: ContentService,
                private router: Router,
                private route: ActivatedRoute,
                protected themeService: ThemeService,
                private readonly snackBar: MatSnackBar,
                public changeDetection: ChangeDetectorRef
    ) {

        this.route.queryParams.subscribe((params): void => {
                if (params['Survey'] || params['survey']) {
                    let surveyID: number = JSON.parse(params['survey']) || JSON.parse(params['Survey'])
                    if (surveyID) {
                        if (params['id'] && this.currentUser && (params['id'] != this.currentUser.id)) {
                            this.openSnackBar('Survey was completed by a different user', 'error')
                            return
                        }
                        this.contentService.postSurveyComplete(surveyID).subscribe((r: any): void => {
                            this.router.navigate(['/feed'], {relativeTo: this.route}).then(function (): void {
                                location.reload();
                            })
                        }, error => {
                            this.router.navigate(['/feed'], {relativeTo: this.route}).then((): void => {
                                this.openSnackBar(error, 'error');
                            });
                        })
                    }
                }
            }
        );

        this.route.params
            .subscribe(params => {
                if (params['post']) {
                    this.contentService.getPostById(params['post']).pipe(take(1))
                        .subscribe(post => {
                            this.contentService.getPostComments(post.id).pipe(take(1)).subscribe((comments): void => {
                                this.changeDetection.detach();
                                const dialogRef: MatDialogRef<CommentsComponent> = this.dialog.open(CommentsComponent, {
                                    data: {
                                        comments: comments,
                                        post,
                                    },
                                    autoFocus: false,
                                    panelClass: ['mediumWindow', 'w-100', 'comments-modal'],
                                });
                                dialogRef.afterClosed().subscribe((): void => {
                                    this.changeDetection.reattach();
                                });
                            }, e => {
                                this.openSnackBar(e, 'error');
                                this.router.navigate(['/feed'], {relativeTo: this.route});
                            });

                            this.router.navigate(['/feed'], {relativeTo: this.route});
                        }, e => {
                            this.openSnackBar(e, 'error');
                            this.router.navigate(['/feed'], {relativeTo: this.route});
                        });
                } else {
                    this.contentService.getCurrentDashboardCommunity()
                        .pipe(takeUntilDestroyed())
                        .subscribe(community => {
                            this.community = community;
                            this.loadPostFromSidebar(this.community?.id || this.currentCommunityId);
                        });
                }
            });
    }

    get isSuperuser(): boolean {
        return this.authService.isSuperUser();
    }

    get currentUser(): User {
        return this.authService.getUser();
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any): void {
        this.isMobile = window.innerWidth <= 1000;
    }

    ngOnInit(): void {
        this.isMobile = window.innerWidth <= 1000;
    }

    hasCommunityRole(roles: UserAccessLevel[]): boolean {
        return this.contentService.userHasCommunityRole(roles);
    }

    newPost(): void {
        this.changeDetection.detach();
        const dialogRef: MatDialogRef<CreatePostComponent> = this.dialog.open(CreatePostComponent, {panelClass: ['largeWindow', 'w-100']});
        dialogRef.afterClosed().pipe(take(1)).subscribe((result: boolean): void => {
            this.changeDetection.reattach();
            if (result) {
                this.dashboardFeedComponent.reloadContent();
            }
        });
        dialogRef.disableClose = true;
    }


    loadPostFromSidebar(id: number | null): void {
        if (!id) return;
        this.loading = true;
        this.contentService.getFeed(id, 1, 1000, {is_pinned_to_sidebar: true, sort_by: 'newest'})
            .pipe(take(1))
            .subscribe({
                next: result => {
                    this.sidebarPosts = result.results;
                    this.loading = false;
                }, error: result => {
                    this.loading = false;
                    this.openSnackBar(result, 'error');
                },
            });
    }


    trackByPostId(index: number, post: any): number {
        return post.id;
    }

    openSnackBar(message: string, type: string): void {
        this.snackBar.open(message, 'Dismiss', {
            duration: 5000,
            panelClass: [type]
        });
    }
}
